module.exports = __webpack_public_path__ + "static/media/NayyerSheet.6082d5a6.xlsx";